// utils/walletUtils.js
import CryptoJS from "crypto-js";

class WalletUtils {
  // Sanitize data (same as PHP sanitize_data)
  static sanitizeData(input) {
    if (!input) return "";

    let searchArr = [
      "document",
      "write",
      "alert",
      "%",
      "@",
      "$",
      ";",
      "+",
      "|",
      "#",
      "<",
      ">",
      ")",
      "(",
      "'",
      "\\'",
      ",",
    ];

    let sanitized = input
      .toString()
      .replace(/script/gi, "")
      .replace(/iframe/gi, "");

    searchArr.forEach((item) => {
      let regex = new RegExp(
        item.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        "gi"
      );
      sanitized = sanitized.replace(regex, "");
    });

    // Equivalent of stripslashes
    sanitized = sanitized
      .replace(/\\'/g, "'")
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, "\\");

    // Equivalent of htmlentities (ENT_QUOTES)
    const entityMap = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    };
    sanitized = sanitized.replace(/[&<>"']/g, (m) => entityMap[m]);

    return sanitized;
  }

  // Generate wallet code (same as PHP walletCode)
  static walletCode(id, guid, amount, userID, planID, BaseAmount, StAMOUNT) {
    const key = "CONNECT";
    const secureCode = "SECURE";

    const requestedId = this.sanitizeData(id);
    const checkCode = this.sanitizeData(guid);
    amount = this.sanitizeData(amount);
    planID = this.sanitizeData(planID);
    userID = this.sanitizeData(userID);
    BaseAmount = this.sanitizeData(BaseAmount.toString().trim());
    StAMOUNT = this.sanitizeData(StAMOUNT.toString().trim());

    const finalCode =
      checkCode +
      secureCode +
      requestedId +
      secureCode +
      "AMOUNT" +
      amount +
      secureCode +
      "USERID" +
      userID +
      secureCode +
      "PLANID" +
      planID +
      BaseAmount +
      StAMOUNT;

    return CryptoJS.SHA256(`${key}-${finalCode}`).toString(CryptoJS.enc.Hex);
  }
}

export default WalletUtils;
